// Thin fetch wrapper. Every call hits Express on the same origin.
// 401 means the session expired or the app was locked — surface it so the
// main app can re-render the login gate.

const BASE = "/api";

async function call(method, path, body) {
  const init = { method, credentials: "same-origin", headers: { "Content-Type": "application/json" } };
  if (body !== undefined) init.body = JSON.stringify(body);
  const res = await fetch(`${BASE}${path}`, init);
  if (res.status === 401) {
    const event = new CustomEvent("cmt:locked");
    window.dispatchEvent(event);
    throw new Error("locked");
  }
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`${method} ${path} failed: ${res.status} ${text}`);
  }
  if (res.status === 204) return null;
  const contentType = res.headers.get("content-type") || "";
  return contentType.includes("application/json") ? res.json() : res.text();
}

export const api = {
  auth: {
    status: () => call("GET", "/auth/status"),
    unlock: (password) => call("POST", "/auth/unlock", { password }),
    lock: () => call("POST", "/auth/lock"),
  },
  loadState: () => call("GET", "/state"),
  templates: {
    upsert: (template) => call("PUT", `/templates/${encodeURIComponent(template.id)}`, template),
    remove: (id) => call("DELETE", `/templates/${encodeURIComponent(id)}`),
  },
  completions: {
    upsert: (key, body) => call("PUT", `/completions/${encodeURIComponent(key)}`, body),
  },
  notes: {
    create: (note) => call("POST", "/notes", note),
    update: (id, patch) => call("PUT", `/notes/${encodeURIComponent(id)}`, patch),
    remove: (id) => call("DELETE", `/notes/${encodeURIComponent(id)}`),
  },
  workLocations: {
    add: (date, location) => call("POST", "/work-locations", { date, location }),
  },
  timeEntries: {
    set: (date, location, minutes) => call("PUT", "/time-entries", { date, location, minutes }),
  },
  extraTimeEntries: {
    create: (entry) => call("POST", "/extra-time-entries", entry),
    update: (id, patch) => call("PUT", `/extra-time-entries/${encodeURIComponent(id)}`, patch),
  },
  config: {
    update: (config) => call("PUT", "/config", config),
  },
  sendReport: (payload) => call("POST", "/send-report", payload),
};
